module.exports = __webpack_public_path__ + "img/musiciansonstage.620f74e0.png";